import { render, staticRenderFns } from "./adminTabPark.vue?vue&type=template&id=aac2102c&scoped=true&"
import script from "./adminTabPark.vue?vue&type=script&lang=ts&"
export * from "./adminTabPark.vue?vue&type=script&lang=ts&"
import style0 from "./adminTabPark.vue?vue&type=style&index=0&id=aac2102c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aac2102c",
  null
  
)

export default component.exports